module.exports = __webpack_public_path__ + "img/arrow_right.b4c836f0.svg";